/**
 *  action的extendParam中所用到的key  这个参数内数据是给框架用 如果使用者在这里面定义了 框架没有用到的key 将会给予提示
 */

const actionExtendParam = ["log"];

function JudgeActionExtendParam(param){
    for(let i in param){
        if(actionExtendParam.indexOf(i)<0){
            console.warn('ExtendParam includes system useless key. Please not pass your own key in ExtendParam. Please cheout out key in file config/actionExtendParam')
        }
    }
}

export default JudgeActionExtendParam;